module.exports = __webpack_public_path__ + "static/media/job-matcher-premium-no-bg.95769f59.svg";